import { ref, onMounted, onUnmounted } from 'vue'

/**
 * H5 网络状态监听
 * 适用于：
 * - App 内嵌 WebView
 * - iOS WKWebView
 * - Android WebView
 * - 浏览器
 */

export function useNetworkStatus() {
  // 是否在线
  const isOnline = ref(navigator.onLine)

  // 网络类型
  const networkType = ref('unknown')

  // 网络速度
  const effectiveType = ref('unknown')

  // 网络延迟
  const ping = ref(0)

  /**
   * 获取网络信息
   */
  const updateConnectionInfo = () => {
    const connection =
      (navigator as any).connection ||
      (navigator as any).webkitConnection ||
      (navigator as any).mozConnection

    if (connection) {
      networkType.value =
        connection.type || 'unknown'

      effectiveType.value =
        connection.effectiveType || 'unknown'
    }
  }

  /**
   * 网络恢复
   */
  const handleOnline = () => {
    isOnline.value = true

    updateConnectionInfo()

    console.log('网络已连接')
  }

  /**
   * 网络断开
   */
  const handleOffline = () => {
    isOnline.value = false

    console.log('网络已断开')
  }

  /**
   * 主动测速（推荐）
   */
  const checkNetworkSpeed = async () => {
    try {
      const start = Date.now()

      await fetch(
        `/ping?t=${Date.now()}`,
        {
          method: 'GET',
          cache: 'no-cache'
        }
      )

      ping.value = Date.now() - start

      console.log(
        '网络延迟:',
        ping.value
      )
    } catch (e) {
      isOnline.value = false

      console.log('测速失败')
    }
  }

  onMounted(() => {
    updateConnectionInfo()

    window.addEventListener(
      'online',
      handleOnline
    )

    window.addEventListener(
      'offline',
      handleOffline
    )

    // 初始测速
    checkNetworkSpeed()

    // 每30秒检测一次
    const timer = setInterval(() => {
      checkNetworkSpeed()
    }, 30000)

    onUnmounted(() => {
      clearInterval(timer)

      window.removeEventListener(
        'online',
        handleOnline
      )

      window.removeEventListener(
        'offline',
        handleOffline
      )
    })
  })

  /**
   * 网络质量
   */
  const getNetworkLevel = () => {
    if (!isOnline.value) {
      return '#FE5F58'
    }

    if (ping.value < 300) {
      return '#F1D205'
    }

    if (ping.value < 1000) {
      return '#29C940'
    }

    return 'poor'
  }

  return {
    isOnline,
    networkType,
    effectiveType,
    ping,
    getNetworkLevel,
    checkNetworkSpeed
  }
}